import { useLocation, useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Expand from '../../components/Navigation/Expand';
import { useContext, useState } from 'react';
import deleteSvg from '../../assets/delete-white.svg';
import { useIframeContext } from '../../context/IframeContext';
import InitiativeDataContext from '../../context/InitiativeDataContext';
import OutcomesDataContext from '../../context/OutcomeDataContext';


function DeleteOutcome() {
    const { isIframe } = useIframeContext();
    const { fetchInitiatives } = useContext(InitiativeDataContext);
    const { fetchOutcomes } = useContext(OutcomesDataContext);
    const [deleteStatus, setDeleteStatus] = useState('');
    const [showImage, setShowImage] = useState(false);
    const [showContinueButton, setShowContinueButton] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate();
    const location = useLocation();
    const { id, initiativeId, from } = location.state;

    // Handler for navigating back to Outcomes page
    const navigateBack = () => {
        navigate(-1);
    };

    const handleClose = () => {
        fetchInitiatives();
        navigate(from);
    }

    const handleNext = async () => {
        
        setError(null);

        try {
            const response = await fetch(`${import.meta.env.VITE_COMMERCE_BACKEND_URL}/api/deleteoutcome?outcomeId=${id}&initiativeId=${initiativeId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.error || 'Failed to delete outcome');
            }

            setDeleteStatus('Outcome deleted successfully');
            setShowImage(true);
            setShowContinueButton(true);
            fetchOutcomes();
            console.log(`Outcome with ID ${id} successfully deleted`);
        } catch (error) {
            // Log the caught error to Sentry
            Sentry.captureException(error);
            console.error('Error deleting data from backend:', error);
            setError('There was an issue deleting the outcome. Please try again later.');
        }
    };
    

    return (
        <div className="m-2 p-4">
            {/* Expand button */}
            {isIframe && 
            <div className='flex justify-end'>
                <div className="flex ml-auto mb-4">
                    <Expand/>
                </div>
            </div>
            }

            {/* Delete Outcome */}
            <div className="mb-8 border border-solid border-titanium-white rounded-md">
                <div className='border-b border-solid border-titanium-white mb-5 bg-gotham-gray rounded-t-md'>
                    <h2 className="text-white font-semibold py-3 ml-7">Delete Outcome</h2>
                </div>
                <div className='flex ml-4 sm:ml-8 h-20 items-center'>
                    {showImage && 
                        <img src={deleteSvg} alt="Deleted Successfully" className="p-2 mr-4 h-9 w-10 border border-red-500 bg-red-500 rounded-full" />
                    }
                    <p className='font-semibold'>
                        {deleteStatus || 'Are you sure that you want to permanently delete the outcome?'}
                    </p>
                </div>
                {/* Display the server error message if it exists */}
                {error && (
                    <div className="text-red-500 text-sm ml-8">
                        {error}
                    </div>
                )}
                <div className='border-t border-solid border-titanium-white mt-5 mb-2'>
                    {!showImage && (
                        <button
                            id="next"
                            onClick={handleNext}
                            className="ml-7 mt-5 mb-3 w-36 h-9 text-center text-white bg-gotham-gray border border-solid border-gotham-gray rounded-md focus:outline-none focus:border-blue-400 hover:bg-blue-400 hover:border-blue-500"
                        >
                            Next
                        </button>
                    )}
                    {!showImage && (
                        <button
                            id="cancel"
                            onClick={navigateBack}
                            className="ml-7 mt-5 mb-3 w-36 h-9 text-center text-gotham-gray bg-white border border-solid border-gotham-gray rounded-md focus:outline-none focus:border-red-500 hover:bg-red-400 hover:border-red-500 hover:text-white"
                        >
                            Cancel
                        </button>
                    )}
                    {showContinueButton && (
                        <button
                            id="close"
                            onClick={handleClose}
                            className="ml-7 mt-5 mb-3 w-36 h-9 text-center text-white bg-gotham-gray border border-solid border-gotham-gray rounded-md focus:outline-none focus:border-blue-400 hover:bg-blue-400 hover:border-blue-500"
                        >
                            Close
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DeleteOutcome;